import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DocumentUploadComponent } from '../document-upload/document-upload.component';
// import { ReactiveFileInputComponent } from '../inputs/reactive-file-input/reactive-file-input.component';
import { ReactiveFileInputBusinessDocumentsComponent } from '../inputs/reactive-file-input-business-documents/reactive-file-input.component';
import { ActivatedRoute } from '@angular/router';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ValidationErrors } from '@angular/forms';
import { ValidationMessageFn } from '../inputs/types/validation-message-fn';

@Component({
  selector: 'app-business-document-upload',
  standalone: true,
  imports: [
    DocumentUploadComponent,
    ReactiveFileInputBusinessDocumentsComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './document-upload.component.html',
  styleUrl: './document-upload.component.scss',
})
export class BusinessDocumentUploadComponent implements OnInit {
  @ViewChild('documentInput', { static: true })
  public documentInput!: ReactiveFileInputBusinessDocumentsComponent;

  @Input() public labelText: string = 'SEC Certificate of Registration';
  @Input() public sampleImageUrl: string[] = [
    '../../../../assets/document-samples/proof-of-billing.png',
  ];
  @Input() public fileControl: FormControl = new FormControl();
  @Input() public documentURL!: string | null;
  @Input() public errors: ValidationErrors | null | undefined = null;
  @Input() public validationMessage: Record<string, ValidationMessageFn> = {};
  @Input() public fromTh: boolean = true;
  businessType: any;
  currentStep: number = 1;
  totalSteps: number = 1;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    const storedBusinessType = localStorage.getItem('selectedBusinessType');
    if (storedBusinessType) {
      this.businessType = JSON.parse(storedBusinessType);
      console.log('Business type', this.businessType);
    }

    this.route.queryParams.subscribe((params) => {
      this.currentStep = +params['current'] || 1;
      this.totalSteps = +params['total'] || 1;
    });
  }
}
